/*
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */


import { Injectable } from '@angular/core';
import { ElSortDirection, ElSortRequest } from '../tree-grid-sort.component';
import { ElTreeGridPresentationNode } from './tree-grid.model';

/**
 * Service used to sort tree grid data. Uses Array.prototype.sort method.
 * If you need custom sorting, you can extend this service and override comparator or whole sort method.
 */
@Injectable()
export class ElTreeGridSortService<T> {

  sort(request: ElSortRequest, data: ElTreeGridPresentationNode<T>[]): ElTreeGridPresentationNode<T>[] {
    if (!request) {
      return data;
    }

    const sorted = data.sort((na, el) => this.comparator(request, na, el));
    for (const node of data) {
      if (node.children) {
        node.children = this.sort(request, node.children);
      }
    }
    return sorted;
  }

  protected comparator(
    request: ElSortRequest,
    na: ElTreeGridPresentationNode<T>,
    el: ElTreeGridPresentationNode<T>,
  ): number {
    const key = request.column;
    const dir = request.direction;
    const a = na.data[key];
    const b = el.data[key];

    let res = 0;

    if (a > b) {
      res = 1
    }
    if (a < b) {
      res = -1
    }

    return dir === ElSortDirection.ASCENDING ? res : res * -1;
  }
}
